module.exports = __webpack_public_path__ + "media/images/city/042-chrysler-building-9e0adc0240e382aacaf724d3ae9b1e3c.svg";